
import { Component, Prop, Vue } from 'vue-property-decorator'
import Icon from '@/components/Icon.vue'
import { Document } from '@/models/Document'
import { namespace } from 'vuex-class'

const Auth = namespace('auth')

@Component({
	components: {
		Icon
	}
})
export default class VesselDocumentExpiryDialog extends Vue {
	@Prop({
		type: Boolean,
		required: true,
		default: false
	})
	opened!: boolean

	@Prop({ required: true })
	document!: Document

	@Auth.Getter('firstDayOfWeek')
	firstDayOfWeek!: string

	isInitializing: boolean = false
	isLoading = true

	expirationDate: string = ''
	expirationDatepickerOpen: boolean = false

	async created() {
		this.isInitializing = true
		if (this.document.expirationDate) {
			this.expirationDate = this.document.parsedExpirationDate.format('YYYY-MM-DD')
		}
		this.isInitializing = false
		this.isLoading = false
	}

	async submit() {
		this.isLoading = true
		this.document.expirationDate = this.expirationDate ?? null
		await this.document.save()
		this.isLoading = false
		this.$emit('closing')
	}
}
